module.exports = __webpack_public_path__ + "static/media/tablet.58d23d2f.svg";